// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2NqD-","footer":"Form_footer__35OV-"};